export const environment = {
  production: false,
  apiBaseUrl: 'http://localhost:8510/api',
  apiAuthBaseUrl: 'http://localhost:8510/api/auth',
  apiWmsUrl: 'http://localhost:8510/api/wms',
  certificateAuthLoginUrl: 'http://localhost:8510/api/auth/certificate/login'
};
